import React from "react";
import Loadable from "react-loadable";
import LoadingSpinnerComponent from "./_components/LoadingSpinnerComponent";

function Loading() {
    return (
        <div>
            <LoadingSpinnerComponent loading={true} center={true} size="4em"/>
        </div>
    );
}

const Home = Loadable({
    loader: () => import("./Home"),
    loading: Loading,
});

const CustomerPortal = Loadable({
    loader: () => import("./CustomerPortal/CustomerPortal"),
    loading: Loading,
});

//https:github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
    // Preview route: renders the real CustomerPortal with ?preview=true for mock data + postMessage live-edit
    {path: "/portal/preview", name: "Kundenportal Vorschau", component: CustomerPortal},
    {
        path: "/portal/:integration/:shopIdentifier/:externalId",
        name: "Kundenportal",
        component: CustomerPortal,
    },
    {
        path: "/portal/:integration/:shopIdentifier",
        name: "Kundenportal",
        component: CustomerPortal,
    },
    {
        path: "/portal/:integration",
        name: "Kundenportal",
        component: CustomerPortal,
    },
    {path: "/portal", name: "Kundenportal", component: CustomerPortal},
    {path: "/", name: "Home", component: Home},
];

export default routes;
